












































































import {Component, Prop, Vue} from "vue-property-decorator";
import SelectStage from "../pages/studio/SelectStage.vue";
import AddGameInfo from "../pages/studio/AddGameInfo.vue";
import AddGameFile from "../pages/studio/AddGameFile.vue";
import Toast from "@/script/message";
import {eGameStage} from "@/common/enumData";


@Component({
    components: {SelectStage, AddGameInfo, AddGameFile},
})

export default class ProjectUpload extends Vue {

    toast = new Toast();

    isClickActive: boolean = false;
    stage: number | null = null;

    isGameInfoFilled: boolean = false;

    isActivePublishBtn: boolean = false;

    //프로젝트 수정
    isEditProject: boolean = false;
    isUpdateProject: boolean = false;
    projectInfo: any = null;


    mounted() {
        //프로젝트 업데이트 경우
        if (this.$route.params.id) {
            this.infoFetch()
        }

    }

    updateProjectInfo() {

    }

    infoFetch() {
        this.$api.getProject(this.$route.params.id)
            .then((res: any) => {
                this.projectInfo = res;
                this.stage = res.stage;
                this.$store.commit("gameStage", this.stage);
                this.$store.commit('projectInfo', res);
                this.isEditProject = true;
            })
    }

    uploadGame() {
        const {gameInfoObj, gameFileInfoObj, uploadGameFiles} = this.$store.getters;

        this.$api.createProject(
            gameInfoObj,
            gameFileInfoObj,
            uploadGameFiles
        )
            .then((res) => {

                this.toast.successToast(`${this.$t('projectUpload.success.upload')}`);
                this.$router.push(`/${this.$i18n.locale}/projectList`)
            })
            .catch((err) => {

            })
    }


    updateProject() {
        this.isUpdateProject = true;
console.log("here?")
        // const option: any = {
        //     id: this.projectInfo.id,
        //     name: localStorage.getItem('title'),
        //     description: localStorage.getItem('description'),
        //     hashtags: localStorage.getItem('hashtagsArr'),
        //     stage: this.$store.getters.gameStage
        // };
        //
        //
        // this.$api.updateProject(option, this.$store.getters.thumbFile)
        //     .then((res) => {
        //         this.toast.successToast("업데이트 되었습니다.");
        //         this.$router.push('/projectList')
        //     })
        //     .catch((err) => {
        //
        //     })
    }

    stepOne() {
        return !this.stage ? true : false;
    }

    stepTwo() {
        return this.stage && !this.isGameInfoFilled ? true : false;
    }

    stepThree() {
        return this.stage && this.isGameInfoFilled
        // && (this.$store.getters.gameStage !== eGameStage.Dev)
            ? true : false;

    }

    getStage(stage: number) {
        this.stage = stage;
    }

    getGameInfo(state: boolean) {
        this.isUpdateProject = false;
        this.isGameInfoFilled = state;
    }

    getPublishState(state: boolean) {
        console.log('isActivePublish', state)
        this.isActivePublishBtn = state;
    }
}
